export default __webpack_public_path__ + "static/media/doc-pdf.e0bcee65.svg";